/**
 * ログアウトの前に、端末に残っている送れていない録音を確かめる（PRODUCT_DEV-1270）
 *
 * 録音とお客さまの情報（社名・担当者・お客様情報）が端末に残ったまま次の人に渡らないよう、
 * ログアウトするなら端末から消す。黙って消すと録音を失うので、件数を出して確かめる。
 * キャンセルしたらログアウトしない（ホームの帯の「今すぐ送る」から送ってからにできる）。
 */
import { handleLogout } from "@/utils/logout";
import { listPending } from "./pendingStore";
import { discardAllPending } from "./pendingRecordings";

export async function confirmLogoutWithPending(
  confirm: (message: string) => boolean = (m) => window.confirm(m),
): Promise<boolean> {
  const items = await listPending();
  if (items.length === 0) return true;
  const ok = confirm(
    `送れていない録音がこの端末に${items.length}件残っています。\n` +
      "ログアウトすると、この端末から消えます。送ってからにするときは「キャンセル」を押し、" +
      "ホームの「今すぐ送る」から送ってください。\nログアウトしますか？",
  );
  if (ok) await discardAllPending();
  return ok;
}

/** メニューの「ログアウト」から呼ぶ */
export const logoutWithPendingCheck = (): void => {
  void confirmLogoutWithPending().then((ok) => {
    if (ok) handleLogout();
  });
};
